import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-internal-order-modal",
  templateUrl: "./internal-order-modal.component.html",
  styleUrls: ["./internal-order-modal.component.sass"],
})
export class InternalOrderModalComponent implements OnInit {
  item: any;
  APIEndpoint = environment.APIEndpoint;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit() {
    const createdAt = new Date(this.item.createdAt);
    this.item.createdAt = createdAt.toLocaleDateString("en-GB");

    console.log("this.item----->>>>>", this.item);
    this.item = this.item || {};
    this.item.orderItems = this.item.orderItems || [];
    this.item.inventoriesNote = this.item.inventoriesNote || [];
  }

  handleCloseModal() {
    this.bsModalRef.hide();
  }
}